module.exports = __webpack_public_path__ + "99af5a94b011d565f7ab92338a3a8186.svg";